import { DataForSearchTour } from 'entities/tour/models/search-tour'

import { DestinationFeedItem } from 'shared/api/tours/main-page'

export const getSearchTourData = ({
  departure_city,
  destination_country,
  search_params,
}: DestinationFeedItem): DataForSearchTour => {
  const destinationCitiesIds = new Set(search_params.destination_cities_ids)
  const resorts = destinationCitiesIds.size
    ? destination_country.cities.filter(({ id }) =>
        destinationCitiesIds.has(id),
      )
    : destination_country.cities

  return {
    departure: departure_city,
    country: destination_country,
    resorts,
    duration: search_params.nights,
    flight: { startDay: search_params.checkin_date },
    passengers: {
      adults: search_params.adult,
      children: search_params.child,
      childrenAges: search_params.ages ?? undefined,
    },
    is_flexible_date: search_params.is_flexible_date,
    is_flexible_nights: search_params.is_flexible_nights,
  }
}
